import React from 'react'
import { useDispatch } from 'react-redux'
import { closeModal } from '@/components/composed/Modal/actions'
import { FinancingUxFeedbackModalAlert } from '../FinancingUxFeedbackModalAlert'
import { messages } from './messages'
import './styles.scss'

export const FinancingUxFeedbackModalSuccess = () => {
  const dispatch = useDispatch()

  const onSuccessAction = () => {
    dispatch(closeModal())
  }

  return (
    <FinancingUxFeedbackModalAlert icon="success" title={messages.thanks} actionMessage={messages.action} onActions={onSuccessAction} />
  )
}
